// Builds the values for a CSS shadow using a shadow token.
// eg: `box-shadow: ${shadow(tokens.shadows.elevation1)};`

var shadowPart = _ref => {
  var x = _ref.x,
    y = _ref.y,
    radius = _ref.radius,
    spread = _ref.spread,
    color = _ref.color;
  return "".concat(x, " ").concat(y, " ").concat(radius, " ").concat(spread ? "".concat(spread) : '', " ").concat(color);
};
var shadow = _ref2 => {
  var key = _ref2.key,
    ambient = _ref2.ambient;
  return "".concat(shadowPart(ambient), ", ").concat(shadowPart(key));
};
export default shadow;